import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=024494e6&scoped=true&"
import script from "./PermissionsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsList.vue?vue&type=style&index=0&id=024494e6&prod&lang=scss&scoped=true&"
import style1 from "./PermissionsList.vue?vue&type=style&index=1&id=024494e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024494e6",
  null
  
)

export default component.exports